'use client'

import { useCallback } from 'react'

import Button from '@components/buttons/button'

import useApplyWithSonicApply from '@components/job/hooks/useApplyWithSonicApply'
import styles from './apply-and-reminder.module.scss'

type ApplyAndReminderProps = {
  jobId: string
  isEligibleToApply: boolean
  redirect: boolean
  externalJobUrl?: string | null
}

const ApplyAndReminder = ({ isEligibleToApply, redirect, externalJobUrl }: ApplyAndReminderProps): JSX.Element => {
  const applyWithSonicApply = useApplyWithSonicApply()

  const handleRedirect = useCallback(() => {
    if (redirect && externalJobUrl) {
      window.open(externalJobUrl, '_blank')
    }
  }, [redirect, externalJobUrl])

  return (
    <div className={styles.apply}>
      <Button
        className={styles['apply-btn']}
        variant="yellow"
        size="lg"
        onClick={redirect ? handleRedirect : applyWithSonicApply}
        disabled={!isEligibleToApply}
      >
        Apply now
      </Button>
    </div>
  )
}

export default ApplyAndReminder
